export const tenancySchedulePrintLayoutCss = `
@page {
  size: landscape;
  margin-top: 15mm;
  margin-bottom: 15mm;
}
@media print {
  .print-layout {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0;
  }
    
   tfoot {
    display: table-row-group;
  }

  table > tfoot > tr > td {
      font-size: 12px;
      padding: 8px; 
      font-weight: bold;
  }
      
  .header, .entity-info, .info-row, h2 {
    margin-bottom: 0.25em !important;
    padding-bottom: 0 !important;
    break-after: avoid-page;
    page-break-after: avoid;
  }
  .table-container, table {
    break-before: avoid-page !important;
    page-break-before: avoid !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  .page-container {
    break-before: avoid-page !important;
    page-break-before: avoid !important;
    break-inside: avoid-page !important;
    page-break-inside: avoid !important;
  }
  thead {
    display: table-header-group;
  }
  tr {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  th {
    background-color: transparent !important;
    -webkit-print-color-adjust: exact;
    color: black !important;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
    
}

.print-layout {
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  padding: 20px;
  /* allow print layout to break across pages */
}

.page-container {
  page-break-after: always;
  break-after: page;
  margin-bottom: 20mm;
}

.page-container:last-child {
  page-break-after: avoid;
}

.header {
  margin-bottom: 20px;
}

.header h2 {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: bold;
}

.entity-info {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.4;
}

.info-row {
  margin-bottom: 5px;
}

.table-container {
  margin-bottom: 10mm; /* space below table before footer */
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

table > thead > tr > th {
  background-color: transparent;
  color: black;
  font-size: 12px;
  font-weight: normal;
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid black;
}

table > tbody > tr > td {
  font-size: 12px;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.left-align {
  text-align: left;
}

.right-align {
  text-align: right;
}

.centre-align {
  text-align: center;
}

.footer {
  /* place footer in normal flow below content */
  margin-top: 10mm;
  width: 100%;
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
}

.page-header {
  margin-bottom: 10px;
  text-align: right;
  font-size: 12px;
  color: #666;
}

.page-number {
  font-weight: bold;
}
`;